import { render, staticRenderFns } from "./volunteerSuccessPage.vue?vue&type=template&id=22831d96&scoped=true"
import script from "./volunteerSuccessPage.vue?vue&type=script&lang=js"
export * from "./volunteerSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./volunteerSuccessPage.vue?vue&type=style&index=0&id=22831d96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22831d96",
  null
  
)

export default component.exports